import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { fill_action } from "../../../actions/fillList_action";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../utils/Loader";
import { forwardRef } from "react";
import Header from "../../../common_components/Header";
import Pagination from "../../../utils/pagination";
import { vendor_list_action,vendor_delete_action } from "../../../actions/master_actions/vendor_action";
import { sessionExpireMessage, tokenInavlidMessage } from "../../../utils/constants";

const CustomInput = forwardRef(
  ({ value, onClick, onChange, disabled }, ref) => (
    <input
      type="text"
      className="form-control"
      value={value}
      onClick={onClick}
      onChange={onChange}
      disabled={disabled}
      ref={ref}
    />
  )
);

class VendorList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isOpen: false,
      isAccordionExpanded: false,
      vendorsList:[],   currentPage: 1,
      VendorID:"",
      CompanyName:"",
      City:"",
      State:"",
      Mobile:"",
      PrimaryEmailID:""
    };
    this.getVendorsList=this.getVendorsList.bind(this);
    this.vendorRecord=this.vendorRecord.bind(this);
    this.updateItem = this.updateItem.bind(this);
  }
  componentDidMount() {
    if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
      console.log("log");
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }
    setTimeout(() => {
      {
        sessionStorage.getItem("roleId") == 4 ? (
          this.props.navigate("/checkList")
        ) : (
          <></>
        );
      }
    }, 10);
    const { userId } = this.state;
    this.setState({
      userId:
        sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
    });
    this.getVendorsList();
  }

  getFillList(value, userId, keyword, keyvalue) {
    this.setState({ isLoading: true });
    this.props
      .fill_action(
        value,
        userId == "" || userId == null ? null : userId,
        keyword != "" ? keyword : null,
        keyvalue != "" ? keyvalue : null
      )
      .then((data) => {
        console.log(data, "daysFillList");
        if (data.error != 1) {
          //   if (value == DaysActionId) {
          //     this.setState({ daysList: data.data, isLoading: false });
          //   }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  getVendorsList = async () => {
    const{vendorsList,CompanyName}=this.state;
    this.setState({ isLoading: true });
    this.props
      .vendor_list_action(
        CompanyName
      )
      .then((data) => {
        if (data.error !== 1) {
          this.setState({
            vendorsList: data.data,
            isLoading: false,
            currentpage: 1,
          });
        } else {
          if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
            //after session expire.....................
            sessionStorage.clear()
            this.props.navigate('/normalView')
            setTimeout(() => {
              toast.error(data.msg, {
                position:"top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
        }else{
          toast.error(data.msg, {
            position:"top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
        }}
      })
      .catch((e) => {
        console.log(e);
      });
  };
  navigateVendorAdd(){    
    this.props.navigate("/vendorAU");
  }
  navigateVendorUpdate(VendorID,StatusID){
    console.log(VendorID,StatusID);
    this.props.navigate("/vendorAU",{
      state: { VendorID: VendorID,StatusID:StatusID },
    });
  }
  handleDelete(VendorID,CompanyName){
    const confirmed = window.confirm(
      `Are you sure you want to delete this Vendor: ${CompanyName}?`
    );

    if (confirmed) {
      this.props
        .vendor_delete_action(VendorID)
        .then((data) => {
          if (data.error !== 1) {
            toast.success(`Vendor: ${CompanyName} Deleted Successfully`, {
              position:"top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
            this.getVendorsList(); // Refresh the holiday list after deletion
          } else {
            if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
              //after session expire.....................
              sessionStorage.clear()
              this.props.navigate('/normalView')
              setTimeout(() => {
                toast.error(data.msg, {
                  position:"top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
          }else{
            toast.error(data.msg, {
              position:"top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }}
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }
  clearFilters = () => {};
  vendorRecord(vendorsList) {
    return (
      <table
        className="table table-bordered table-striped"
        id="dashboard-table"
      >
        <thead>
          <tr>
          <th >Vendor Name</th>
            <th >Service Name</th>
            <th className="text-center" >
              Contact No
            </th>
            <th className="text-center" >
              Email Address
            </th>
            <th className="text-center" >
              Status
            </th>
            <th className="text-center" >
              Action
            </th>
          </tr>
        </thead>
        <tbody id="myTable">
          {vendorsList != "" && vendorsList != null ? (
            vendorsList.map((item) => (
              <tr>
                <td>{item.CompanyName}</td>
                <td>{item.ThirdPartyServices}</td>
               
                <td class="text-center">
                  {item.Mobile}
                </td>
                <td class="text-center">
                  {item.PrimaryEmailID}
                </td>
                <td class="text-center">
                  {item.StatusID==1?"Active":"Inactive"}
                </td>
                <td class="text-center">
                  <a
                    href="javascript:void(0);"
                    onClick={() => this.navigateVendorUpdate(item.VendorID,item.StatusID)}
                    title="Edit"
                    className="btn btn-sm"
                  >
                    <i className="fa fa-edit action_btn_table" />
                  </a>
                  <a
                    title="Delete"
                    className="btn btn-sm delete_record"
                    onClick={() => this.handleDelete(item.VendorID,item.CompanyName)}
                  >
                    <i className="fa fa-trash action_btn_table" />
                  </a>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8">No data available</td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }
  updateItem(item) {
    this.setState({ currentPage: item });
  }

  render() {
    const {
      isLoading,vendorsList,
      isAccordionExpanded,
      currentPage,CompanyName
    } = this.state;
    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = vendorsList.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const nPages = Math.ceil(vendorsList.length / recordsPerPage);
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">
            <Header data={[21]} />

            <section style={{ marginTop: 115 }}>
              <div className="container-fluid">
                <div className="page-header">
                  <h4 className="page-title">List of Vendors</h4>
                  <div>
                    <a
                      href="javascript:void(0);"
                      onClick={() => this.navigateVendorAdd()}
                      className="btn btn-primary btn-sm create_btn"
                    >
                      <i className="fa fa-plus" />{" "}
                      <span className="hidden-xs">Add</span>
                    </a>
                  </div>
                </div>
                <div className="search_accordion search_card">
                  <div className="panel-group" id="accordion">
                    <div className="panel panel-default">
                      <div
                        className="panel-heading accordion-toggle collapsed"
                        data-toggle="collapse"
                        data-parent="#accordion"
                        data-target="#collapseOne"
                        aria-expanded={isAccordionExpanded}
                        onClick={() =>
                          this.setState({
                            isAccordionExpanded: !isAccordionExpanded,
                          })
                        }
                      >
                        <h4 className="panel-title">Search:</h4>
                        <div className="searched_items">
                          <h5>
                            Vendor Name : <span>{CompanyName}</span>
                          </h5>
                         
                        </div>
                      </div>
                      <div
                        id="collapseOne"
                        className={`panel-collapse collapse ${
                          isAccordionExpanded ? "show" : ""
                        }`}
                        aria-labelledby="headingOne"
                      >
                        <div className="panel-body">
                          <div className="row mr_0">
                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Vendor Name</label>
                                <input
                                  type="text"
                                  value={CompanyName}
                                  onChange={(e) =>
                                    this.setState({ CompanyName: e.target.value })
                                  }
                                  className="form-control search_form_control"
                                  placeholder="Vendor Name"
                                />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <label>&nbsp;</label>
                              <button
                                onClick={()=>this.getVendorsList()}
                                className="btn btn-primary search_btn"
                              >
                                Search
                              </button>
                              &nbsp;
                              <button
                                onClick={() => {
                                  this.setState({ CompanyName: "" }, () => {
                                    this.getVendorsList();
                                  });
                                }}
                                
                                className="btn btn-primary search_btn"
                              >
                                Clear
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="custom_table">
                  <div className="hack1">
                    <div className="hack2">
                      {this.vendorRecord(currentRecords)}
                      {vendorsList.length > 0 ? (
                        <Pagination
                          nPages={nPages}
                          currentPage={currentPage}
                          setCurrentPage={this.updateItem}
                        />
                        ) : (
                          <></>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
          <div id="createActivity" className="modal fade" role="dialog">
            <div
              className="modal-dialog custom_modal_dialog modal-dialog-centered"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="hearingModalLabel">
                    Add/Edit Event
                  </h5>
                  <button
                    type="button"
                    className="close modal_close_icon"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="row">
                      <div className="form-group col-md-4">
                        <label htmlFor="inputZip">
                          Event Name <span className="required_field">*</span>{" "}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="fname"
                          name="name"
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="form-group col-md-4">
                        <div className="Service_display pt-2">
                          <h6 className="Services_Active_or_Not">
                            Event Status
                          </h6>
                          <div className="checkbox checbox-switch">
                            <label className="switch">
                              <input type="checkbox" />
                              <span className="slider round" />
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <button type="submit" className="btn save_btn mr-2">
                          Save
                        </button>
                        <a
                          className="btn back_btn"
                          id="cancel_co_applicant_pop"
                          data-dismiss="modal"
                        >
                          Cancel
                        </a>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <ToastContainer />
        </>
      </>
    );
  }
}

export default withRouter(connect(null, { fill_action,vendor_list_action,vendor_delete_action })(VendorList));
